(function () {
  const cards = document.querySelectorAll('[data-product-handle]');
  if (!cards.length) return;

  cards.forEach(function (card) {
    const handle = card.getAttribute('handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        const badge = card.querySelector('.badge--sold-out');
        if (!badge) return;

        // Vérifie si AU MOINS un variant est disponible
        const anyAvailable = product.variants.some(function (v) {
          return v.available;
        });

        if (anyAvailable) {
          // Produit disponible : masquer le badge rupture
          badge.style.display = 'none';
        }
        // Si toujours en rupture : on ne touche à rien, le badge reste
      })
      .catch(function (err) {
        console.warn('[EN] Collection stock check failed for', handle, err);
      });
  });
})();
